import { render } from "./ApproveLeave.vue?vue&type=template&id=30ab7ba0&scoped=true"
import script from "./ApproveLeave.vue?vue&type=script&lang=js"
export * from "./ApproveLeave.vue?vue&type=script&lang=js"

import "./ApproveLeave.vue?vue&type=style&index=0&id=30ab7ba0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30ab7ba0"]])

export default __exports__